module.exports = __webpack_public_path__ + "static/media/icon-audio.d5c99f48.svg";